import { DeviceService } from '../../services/deviceService';
import { DeviceState } from './types';

export function deviceReducer(state: DeviceState | undefined): DeviceState {
  if (state === undefined) {
    const deviceId = DeviceService.getDeviceId();
    return {
      deviceId: deviceId,
    };
  }

  return state;
}
